<template>
	<a-button :type="btnType" :ghost="ghost" :danger="danger" :class="btnClass" @click="handleActionConfirm">
		<!-- <a-tooltip destroy-tooltip-on-hide :title="btnText" placement="top"> -->
		<slot name="btnText"><i class="icon" :class="btnIcon" v-if="btnIcon" />{{ btnText }}</slot>
		<!-- </a-tooltip> -->
	</a-button>
</template>

<script>
import Core from '../../core';
export default {
	props: {
		btnIcon: { type: String, default: '' },
		btnType: { type: String, default: 'link' },
		btnText: { type: String, default: '删除' },
		btnClass: { type: String, default: 'icon-btn' },
		ghost: { type: Boolean, default: false },
		danger: { type: Boolean, default: true },

		confirmTitle: { type: String, default: '确认删除吗？' },
		confirmContent: { type: String, default: '' },
		confirmOkText: { type: String, default: '确认' },
		confirmCancelText: { type: String, default: '取消' },

		module: { type: String, default: '_', request: true }, // 接口模块名称
		func: { type: String, default: 'delete' }, // 接口名称
		params: { type: Object },
	},
	methods: {
		handleActionConfirm() {
			this.$confirm({
				title: this.confirmTitle,
				content: this.confirmContent,
				okText: this.confirmOkText,
				cancelText: this.confirmCancelText,
				okType: this.danger ? 'danger' : 'primary',
				onOk: () => {
					this.handleAction();
				},
			});
		},
		handleAction() {
			Core.Api[this.module]
				[this.func](this.params)
				.then(() => {
					this.$message.success('操作成功');
					this.$emit('change');
				})
				.catch((err) => {
					console.log('handleAction err', err);
				});
		},
	},
};
</script>
